/* globals window */

export default function identifyForFullStory(fullStory, editorModel) {
  fullStory.identify(editorModel.editorSessionId, {
    userId: editorModel.permissionsInfo.loggedInUserId,
    userAgent: window.navigator.userAgent,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width
  })
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/editor/identifyForFullStory.js